import { Footer } from "../components/Footer";
import logo from "../assets/imgs/custom-logo.svg";

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <div className="h-20 bg-primary flex justify-center items-center">
        <img src={logo} alt="logo" className="w-fit h-10" />
      </div>
      <div className="flex-1 flex justify-center items-start py-10 px-8">
        <div className="bg-white rounded-xl shadow-lg p-10 w-full max-w-[1240px] min-h-[500px] flex flex-col">
          <h1 className="text-2xl font-bold mb-6 text-center text-primary">
            翰林 AI 國文寫作批改使用者條款
          </h1>
          <div className="flex-1 text-gray-700 text-base leading-relaxed flex flex-col gap-4">
            <p>
              <p className="font-bold text-lg">1. 使用目的與特性</p>
              <p className="pl-4">
                <p>
                  翰林 AI
                  國文寫作批改（以下簡稱「本網站」）是由翰林出版事業股份有限公司（以下簡稱「翰林」）結合生成式人工智慧工具開發的
                  AI
                  高中國文作文批改服務，旨在協助使用者獲得快速的批改回饋以提升國文作文實力。
                </p>
                <p className="pt-1">
                  <p className="font-bold"> (1) AI 輔助寫作學習</p>{" "}
                  <p className="pl-4">
                    翰林致力於使用各式先進科技來提供高品質的服務，經過嚴謹的評估測試，認為
                    AI
                    工具已經大致能夠穩定且正確地針對國文作文進行批閱、糾錯、提供建議。因此，翰林建立本網站來透過
                    AI 工具輔助學生提升寫作技能。然而，生成式 AI
                    技術仍在持續發展當中，有時無法全面理解人類語言的複雜性及其細微差異，導致批改結果可能存在誤差。建議使用者在使用本網站時，應自行評估本網站生成內容的適用性、驗證資訊的準確性，並將
                    AI
                    提供的回饋作為進一步學習和改進寫作的起點，必要時還可考慮尋求教師或專業人士的意見。
                  </p>
                </p>
                <p className="pt-1">
                  <p className="font-bold"> (2) 同時批改數量上限</p>
                  <p className="pl-4">
                    本網站同時能提供的 AI
                    國文作文批改服務數量，會受到技術供應商設定的額度限制，這代表本網站在短時間內若被使用的次數過多，將會暫時停止提供批改服務。建議使用者在關鍵時期應提前提交作業，或者稍候一段時間之後再使用，以避免因暫停服務導致的不便。
                  </p>
                </p>
              </p>
            </p>
            <p>
              <p className="font-bold text-lg">2. 資料留存期限</p>
              <p className="pl-4">
                翰林需要對本網站使用者上傳的國文作文或 AI
                生成資料支付雲端數據儲存成本，因此，本網站對使用者上傳的國文作文與
                AI
                批改結果將僅保存三個月，此期限預計已足以支持學習的需求；逾期後，相關資料將自動從系統中刪除。使用者應在資料被刪除前，自行備份相關所需要的資料，本網站將不另行通知，亦不負擔相關資料的保存或尋回之責任。
              </p>
            </p>
            <p>
              <p className="font-bold text-lg">3. 個資保護</p>
              <p className="pl-4">
                翰林為保障使用者的個人資料及隱私權，將對使用者在使用本網站過程中提供的個人資訊（如：註冊的姓名、電子郵件地址等）進行保護。使用者的個人資料將僅用於提供和改善服務，包括但不限於國文作文批改、客服支援和通知。翰林會採取適當的安全措施，以防止未經授權的存取、揭露、修改或銷毀個人資料。
              </p>
            </p>
            <p>
              <p className="font-bold text-lg">4. 禁止事項</p>
              <p className="pl-4">
                本網站專為教育目的設計，僅供教師和學生在教學過程中使用。嚴禁將本網站提供的服務轉用於任何營利目的，包括但不限於出售本網站提供的服務、使用批改服務來獲得任何形式的商業利益。違反這些條款的使用者將會被限制或終止其使用權限，並須承擔相應的法律責任與求償。{" "}
              </p>
            </p>
            <p>
              <p className="font-bold text-lg">5. 修改和更新</p>
              <p className="pl-4">
                翰林擁有對本網站進行修改的權利。本網站目前為 beta
                搶先體驗版，故本網站提供的 AI
                國文作文批改工具功能、設計以及網站的使用者條款，可能會不定期進行更新和改進，以提升使用者的體驗和批改的準確性。使用者在使用前應查看本網站，以了解任何可能影響使用方式的重大變更。
              </p>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
